import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const villageSitesDetails = createSlice({
  name: "villageSitesDetails",
  initialState,
  reducers: {
    fetchVillageSitesDetailsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchVillageSitesDetailsSuccess(state, action) {
      console.log("fetchDataSuccess sites success");
      state.loading = false;
      
      const tempData = action.payload;
      state.data = tempData;
      console.log("Sites details are", state.data)
      console.log("fetchDataSuccess sites success data");
    },
    fetchVillageSitesDetailsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchVillageSitesDetailsStart,
  fetchVillageSitesDetailsSuccess,
  fetchVillageSitesDetailsFailure,
} = villageSitesDetails.actions;
export default villageSitesDetails.reducer;
